import { on } from '@ember/modifier';
import preventDefault from 'volta/helpers/prevent-default';
import stopPropagation from 'volta/helpers/stop-propagation';

import type { TOC } from '@ember/component/template-only';
import noop from '@nullvoxpopuli/ember-composable-helpers/helpers/noop';

interface BvUnstyledLinkSignature {
  Args: {
    ariaDescribedBy?: string;
    ariaLabel?: string;
    external?: boolean;
    onClick?: (e: Event) => void;
    text?: string;
    url?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLAnchorElement;
}

const BvUnstyledLinkComponent: TOC<BvUnstyledLinkSignature> = <template>
  <a
    href={{@url}}
    data-bv-unstyled='true'
    target={{if @external '_blank'}}
    rel={{if @external 'noopener noreferrer'}}
    aria-label={{@ariaLabel}}
    aria-describedby={{@ariaDescribedBy}}
    ...attributes
    {{on 'click' (if @onClick (stopPropagation (preventDefault @onClick)) (noop))}}
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{@text}}
    {{/if}}
  </a>
</template>;

export default BvUnstyledLinkComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvUnstyledLink: typeof BvUnstyledLinkComponent;
    'bv-unstyled-link': typeof BvUnstyledLinkComponent;
  }
}
